import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  Typography,
  Chip,
} from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { Document as DocumentType } from '../../types';

interface DocumentDialogProps {
  open: boolean;
  onClose: () => void;
  document: DocumentType | null;
  documentUrl: string | null;
  PaperProps?: {
    sx?: {
      [key: string]: any;
    };
  };
  sx?: {
    [key: string]: any;
  };
}

const DocumentDialog: React.FC<DocumentDialogProps> = ({
  open,
  onClose,
  document,
  documentUrl,
  PaperProps,
  sx,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Document Details</DialogTitle>
      <DialogContent>
        {document && (
          <Box sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="text.secondary">
                  Document Name
                </Typography>
                <Typography variant="body1" gutterBottom>
                  {document.name}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="text.secondary">
                  Type
                </Typography>
                <Typography variant="body1" gutterBottom>
                  {document.type}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="text.secondary">
                  Version
                </Typography>
                <Typography variant="body1" gutterBottom>
                  {document.version}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="text.secondary">
                  Upload Date
                </Typography>
                <Typography variant="body1" gutterBottom>
                  {new Date(document.uploadDate).toLocaleDateString()}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="text.secondary">
                  Size
                </Typography>
                <Typography variant="body1" gutterBottom>
                  {(document.size / 1024 / 1024).toFixed(2)} MB
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="text.secondary">
                  Status
                </Typography>
                <Chip
                  label={document.status}
                  color={document.status === 'approved' ? 'success' : 'default'}
                  size="small"
                  sx={{ mt: 1 }}
                />
              </Grid>
              
              {/* Document Preview */}
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                  Preview
                </Typography>
                <Box sx={{ p: 4, textAlign: 'center' }}>
                  <Button
                    variant="contained"
                    startIcon={<DownloadIcon />}
                    onClick={() => documentUrl && window.open(documentUrl, '_blank')}
                  >
                    Download Document
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentDialog; 